import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { createPortal } from "react-dom";

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 fade-up">
    <div>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight" data-testid="page-title">
        {title}
      </h1>
      {subtitle && <p className="mt-2 text-sm text-slate-400">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

const TONES = {
  vigente: ["Vigente", "bg-cyan-500/10 border-cyan-500/30 text-cyan-300"],
  convertida: ["Convertida", "bg-violet-500/10 border-violet-500/30 text-violet-300"],
  anulada: ["Anulada", "bg-rose-500/10 border-rose-500/30 text-rose-300"],
  pendiente: ["Pendiente", "bg-amber-500/10 border-amber-500/30 text-amber-300"],
  pagada: ["Pagada", "bg-emerald-500/10 border-emerald-500/30 text-emerald-300"],
  ok: ["Stock OK", "bg-emerald-500/10 border-emerald-500/30 text-emerald-300"],
  bajo: ["Stock bajo", "bg-amber-500/10 border-amber-500/30 text-amber-300"],
  agotado: ["Sin stock", "bg-rose-500/10 border-rose-500/30 text-rose-300"],
  servicio: ["Servicio", "bg-slate-500/10 border-slate-500/30 text-slate-300"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = TONES[status] || [status, TONES.servicio[1]];
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2.5 py-0.5 rounded-full border text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
};

export const stockState = (p) =>
  p.type === "servicio" ? "servicio" : p.stock <= 0 ? "agotado" : p.stock <= p.min_stock ? "bajo" : "ok";

export const Kpi = ({ label, value, icon: Icon, accent = "#00F0FF", testId, hint }) => (
  <div className="panel p-5 fade-up hover:border-[#00F0FF]/40 transition-colors" data-testid={testId}>
    <div className="flex items-center justify-between">
      <span className="label-cap">{label}</span>
      {Icon && <Icon className="w-5 h-5" style={{ color: accent }} />}
    </div>
    <div className="mt-3 text-2xl font-bold text-white mono truncate">{value}</div>
    {hint && <div className="mt-1 text-xs text-slate-400">{hint}</div>}
  </div>
);

export const Empty = ({ text }) => (
  <div className="py-14 text-center text-sm text-slate-500" data-testid="empty-state">{text}</div>
);

export const Confirm = ({ title, description, onConfirm, children, actionLabel = "Confirmar" }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
    <AlertDialogContent className="bg-[#120E2E] border-[#271E56]">
      <AlertDialogHeader>
        <AlertDialogTitle className="text-white">{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel">Cancelar</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="btn-neon" data-testid="confirm-ok">
          {actionLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

// Copia del documento que solo aparece al imprimir (ver App.css)
export const PrintPortal = ({ children }) => createPortal(<div className="print-root">{children}</div>, document.body);
